<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Perfil</th>
                <th :class="StyleTh">username</th>
                <th :class="StyleTh">Ver Precios</th>
                <th :class="StyleTh">Estatus</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.NombreCompleto}}</h6></td>
                    <td><p v-if="lista.perfil != null && lista.perfil != undefined" :class="StyleTd">{{lista.perfil.Nombre}}</p></td>
                    <td><p :class="StyleTd">{{lista.username}}</p></td>
                    <td><p :class="StyleTd">{{lista.VerCotizacion}}</p></td>
                    <td>
                        <span class="badge text-bg-success" v-if="lista.Estatus == 'A'">Activo</span>
                        <span class="badge text-bg-warning" v-if="lista.Estatus == 'B'">Inactivo</span>
                        
                    </td>
                    
                    <td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdUsuario" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">

                                <template v-if="segurity.ChaneAccess">
                                    <button class="btn btn-success btn-icon btn-sm rounded me-2" @click="cambiarAcceso(lista)" title="Cambiar Accesos" >
                                        <i class="fa fa-key" aria-hidden="true"></i>
                                    </button>
                                </template>

                            </template>
						</CBtnAccion>     
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="14"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>

        <CModal :pConfigModal="ConfigModalAccesos" :poBtnSave="oBtnSaveAccesos">
			<template slot="Form">
				<FormAccesos :poBtnSave="oBtnSaveAccesos"></FormAccesos>
			</template>
		</CModal>


	</div>
</template>

<script>

import moment from 'moment';
import Form from '@/views/modulos/usuarios/Form.vue';
import FormAccesos from './FormAccesos.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionUsuario';
const EmitAccesos = 'seccionModAccesos';

export default {
    name: 'ListaUsuario',
    props:['pOrigen','pObjEnviado'],
    components: {
        Form,
        FormAccesos
    },
    data() {
        return {
            ConfigList:{
                Title: 'Listado de Usuarios',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                BtnReturnShow: true,
                ShowTitleFirst: false,
                EmitSeccion: EmitEjecuta,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario Usuarios",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize: 'lg'
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },

            ConfigModalAccesos:{
                ModalTitle: "Cambiar Accesos",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitAccesos,
                ModalSize: 'md'
            },
            oBtnSaveAccesos: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitAccesos,
            },
            
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjCliente: {
                IdCliente: 0,
            },
            isOnlyUsers: 0,
            origen: ''
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("users",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdCliente: this.ObjCliente.IdCliente,
                    onlyUsers: this.isOnlyUsers
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('users/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },

        Regresar(){
            this.$router.push({name:'clientes',params:{}});
        },

        cambiarAcceso(item){
            this.bus.$emit('NewModal_'+EmitAccesos,item.IdUsuario);
        }
    },
    created()
    {   
        if(this.pOrigen != undefined) {
            sessionStorage.setItem('origen',this.pOrigen);
            this.origen = this.pOrigen;

        }else {
            if(sessionStorage.getItem('origen') != undefined && sessionStorage.getItem('origen') != null ) {
                this.origen = sessionStorage.getItem('origen');
            }
        }

        if(this.origen != 'Menu') {

            this.ConfigList.BtnReturnShow = true;

            if(this.pObjEnviado != undefined) {
                sessionStorage.setItem('objGeneral',JSON.stringify(this.pObjEnviado));
            }

            if(sessionStorage.getItem('objGeneral') != undefined && sessionStorage.getItem('objGeneral') != null ) {
                this.ObjCliente = JSON.parse(sessionStorage.getItem('objGeneral'));
            }else {
                this.ObjCliente.IdCliente = 0;
            }
                
            
            this.isOnlyUsers = 0;
            this.ConfigList.Title = this.ConfigList.Title+' del cliente: '+this.ObjCliente.Nombre;
        }else {
            this.isOnlyUsers = 1;
            this.ConfigList.BtnReturnShow = false;
        }
        

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
